export default __webpack_public_path__ + "static/userJoin5-8942f4de9bf8abb740555a6431078ea0.jpg";